import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import DrawerAppBar from './Components/AppBar/DrawerAppBar';
import Footer from './Components/Footer/Footer';
import Loader from './Components/Loader/Loader';
import ScrollToTop from './Components/ScrollToTop/ScrollToTop';
import NotFoundPage from './Pages/NotFoundPage/NotFound';
const EDRPage = React.lazy(() => import('./Pages/EDRPage/EDR'));
const FitXIIIPage = React.lazy(() => import('./Pages/FitXIIIPage/FitXIII'));
const SilverXIIIPage = React.lazy(
  () => import('./Pages/SilverXIIIPage/SilverXIII'),
);
const TagXIIIPage = React.lazy(() => import('./Pages/TagXIIIPage/TagXIII'));
const Home = React.lazy(() => import('./Pages/HomePage/Home'));
const Contact = React.lazy(() => import('./Pages/ContactPage/Contact'));
const Subscription = React.lazy(
  () => import('./Pages/SubscriptionPage/Subscription'),
);
const PartnersPage = React.lazy(() => import('./Pages/PartnersPage/Partners'));

const App: React.FC = () => {
  return (
    <Router
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <DrawerAppBar />
      <ScrollToTop />
      <main id="main-content">
        {/* Suspense global autour des Routes */}
        <Suspense fallback={<Loader />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/partenaires" element={<PartnersPage />} />
            <Route path="/inscriptions" element={<Subscription />} />
            <Route path="/ecole-de-rugby" element={<EDRPage />} />
            <Route path="/fit" element={<FitXIIIPage />} />
            <Route path="/silver" element={<SilverXIIIPage />} />
            <Route path="/tag" element={<TagXIIIPage />} />
            <Route path="/*" element={<NotFoundPage />} />
          </Routes>
        </Suspense>
      </main>
      <Footer />
    </Router>
  );
};

export default App;
